import CompetitionTabHeader from "../../CompetitionTabHeader"
import React, {
  useState,
  useContext,
  useCallback,
} from "react"
import { useToasts } from "react-toast-notifications"
import DrawActionLogs from "./DrawActionLogs"
import DrawPlayerDetails from "../../components/DrawPlayerDetails"
import DrawPositions from "./DrawPositions"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { EVENT_DETAILS_READ_MODE_COMPETITION } from "../../../../../eventDetailsReadPolicy"
import { store as socketStore } from "components/Common/Socket/store"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { getEventDetails as getEventDetailsAction } from "../../../../../actions"
import { Card, CardBody } from "reactstrap"
import { getMainDrawConfirmationCopy } from "./mainDrawConfirmation"
import { drawPublicationNotice } from "./drawPublicationNotice"
import useDrawOperation from "./useDrawOperation"
import DrawOperationFeedback from "./DrawOperationFeedback"
import { drawLockReason } from "./drawFeedbackCopy"
import { getMainDrawXls } from "../../../../../api"
import { invalidateEventCache } from "../../../../../eventCachePolicy"
import { isTenis10Event } from "../../../../../tenis10Event"
import GameSheetsButtons from "../Matches/GameSheetsButtons"


const Eliminatory = props => <DrawPositions {...props} drawModel="eliminatory" />
const Groups = props => <DrawPositions {...props} drawModel="groups" />

export const Draw = ({
  competitionDetails: {
    luckyDraw = [],
    drawModel,
    numberOfGroups,
    gameType,
  } = {},
  getEventDetails,
  eventDetails = [],
  loading = false,
  error = null,
  match,
  fetchMatches,
  matches,
  drawOperation,
  userDetails,
}) => {
  const { addToast } = useToasts()
  const globalState = useContext(socketStore)
  const { state: { socket: { socketClientId, socket } = {} } = {} } = globalState
  const [modal, setModal] = useState(null)
  const { id: eventId, competitionId } = match.params
  const [mainDrawConfirmation, setMainDrawConfirmation] = useState(null)
  const [generatingXls, setGeneratingXls] = useState(false)
  const refreshEventDetails = useCallback(
    targetEventId => {
      invalidateEventCache({ eventId: targetEventId, competitionId })
      getEventDetails(
        targetEventId,
        EVENT_DETAILS_READ_MODE_COMPETITION,
        competitionId
      )
    },
    [competitionId, getEventDetails]
  )

  const localOperation = useDrawOperation({ eventId, competitionId, userId: userDetails?.id || userDetails?._id,
    socket, socketClientId, refresh: refreshEventDetails, addToast, enabled: !drawOperation })
  const operation = drawOperation || localOperation
  const mainDrawActionDisabled = operation.locked
  const mainDrawActionLabel = operation.action === "generate" && operation.status === "pending" ? "Generating Main Draw..." : "Generate Main Draw"

  let currentCompetition = eventDetails[0]?.competitions?.filter(
    competition => competition?._id === competitionId
  )[0]

  const openMainDrawConfirmation = phaseId =>
    setMainDrawConfirmation({
      phaseId,
      drawModel: currentCompetition?.drawModel,
      hasNoPhaseWarning:
        !phaseId &&
        currentCompetition?.phases?.length === 0 &&
        currentCompetition?.drawModel === "groups",
      // P72: what generating does to the event stage
      statusNotice: drawPublicationNotice(eventDetails[0]?.currentPhase?.status, eventDetails[0]?.phases),
      timezone: eventDetails[0]?.timezone,
    })

  const closeMainDrawConfirmation = () => setMainDrawConfirmation(null)

  const confirmMainDraw = () => {
    operation.run("generate", { phaseId: mainDrawConfirmation?.phaseId })
    closeMainDrawConfirmation()
  }
  const feedback = !drawOperation && <DrawOperationFeedback operation={operation} competition={currentCompetition} />

  if (error) return <div className="competition-lucky-draw"><CompetitionTabHeader title="Lucky Draw" />
    {feedback}
    <div role="alert">Lucky Draw could not be loaded. <Button color="link" onClick={() => refreshEventDetails(eventId)}>Retry Lucky Draw</Button></div>
  </div>
  if (loading || !eventDetails.length || (eventDetails[0]?._id && eventDetails[0]._id !== eventId)) return <div className="competition-lucky-draw"><CompetitionTabHeader title="Lucky Draw" />{feedback}<p role="status">Loading Lucky Draw…</p></div>
  if (!currentCompetition) return <div className="competition-lucky-draw"><CompetitionTabHeader title="Lucky Draw" /><p role="alert">Competition could not be found.</p></div>

  return (
    <div className="competition-lucky-draw">
      <DrawPlayerDetails competition={currentCompetition}>
      <CompetitionTabHeader title="Lucky Draw" />
      {feedback}
      <div className="lucky-draw-content">
        {!luckyDraw.length && <NotGeneratedDraw eventId={eventId} competitionId={competitionId} />}
        {luckyDraw.length ? (
          <div className="lucky-draw-primary">
            <h3>{`Competition (${drawModel[0]?.toUpperCase() + drawModel?.slice(1)})`}</h3>

            <div>
              {drawModel === "groups" ? (
                <Groups
                  operation={operation}
                  socketClientId={socketClientId}
                  currentCompetition={currentCompetition}
                  eventId={eventId}
                  competitionId={competitionId}
                  gameType={gameType}
                  luckyDraw={luckyDraw}
                  numberOfGroups={numberOfGroups}
                  eventContext={eventDetails[0]}
                  allCompetitions={eventDetails[0]?.competitions}
                  eventEntryCounts={eventDetails[0]?.entryCountsByPlayerId}
                />
              ) : (
                <Eliminatory
                  currentCompetition={currentCompetition}
                  operation={operation}
                  socketClientId={socketClientId}
                  eventId={eventId}
                  competitionId={competitionId}
                  gameType={gameType}
                  luckyDraw={luckyDraw}
                  eventContext={eventDetails[0]}
                  allCompetitions={eventDetails[0]?.competitions}
                  eventEntryCounts={eventDetails[0]?.entryCountsByPlayerId}
                />
              )}
              <DrawActionGroup operation={operation}>
                <Button
                  color="success"
                  disabled={operation.locked}
                  onClick={() => setModal("redraw")}
                  className="mb-4 mt-3"
                >
                  Redraw
                </Button>
                <Button
                  onClick={() => openMainDrawConfirmation()}
                  className="pl-2 pr-2 mb-4 mt-3 ml-2"
                  color="success"
                  disabled={mainDrawActionDisabled}
                >
                  {mainDrawActionLabel}
                </Button>
                {/* P54: a Tenis10 competition prints its game sheets (PDF / XLS) in place of the adults' Main Draw XLS. */}
                {isTenis10Event(eventDetails[0]) ? (
                  <GameSheetsButtons eventId={eventId} competitionId={competitionId} disabled={operation.locked} className="mb-4 mt-3 ml-2" />
                ) : (
                  <Button color="primary" className="mb-4 mt-3 ml-2" disabled={generatingXls || operation.locked}
                    onClick={() => getMainDrawXls({ eventId, competitionId, addToast, setGeneratingXls })}>
                    {generatingXls ? "Generating .XLS..." : "Generate Main Draw .XLS"}
                  </Button>
                )}
              </DrawActionGroup>
              <p className="text-muted">{isTenis10Event(eventDetails[0])
                ? "The game sheets print the saved Main Draw with its results, or a preview from Lucky Draw when no matches exist."
                : "Excel exports the saved Main Draw, or a preview from Lucky Draw when no matches exist."}</p>
            </div>
          </div>
        ) : (
          ""
        )}
        {currentCompetition?.phases?.map((phase, idx) => (
          <>
            {phase?.luckyDraw?.length ? (
              <div className="phaseCol mr-5" key={idx}>
                {currentCompetition?.drawModel === "groups" &&
                currentCompetition?.phases[0]?.drawModel === "eliminatory" ? (
                  ""
                ) : (
                  <h3>
                    Phase{" "}
                    {`(${
                      phase.drawModel[0]?.toUpperCase() +
                      phase.drawModel?.slice(1)
                    })`}
                  </h3>
                )}
                {/* Phase draws are generated from Phases; a swap here would PATCH the competition's own Lucky Draw. */}
                {phase?.drawModel === "groups" ? (
                  <Groups
                    readOnly
                    currentCompetition={currentCompetition}
                    operation={operation}
                  socketClientId={socketClientId}
                    eventId={eventId}
                    competitionId={competitionId}
                    gameType={phase.gameType}
                    phaseId={phase._id}
                    luckyDraw={phase.luckyDraw}
                    numberOfGroups={phase.numberOfGroups}
                    eventContext={eventDetails[0]}
                    allCompetitions={eventDetails[0]?.competitions}
                    eventEntryCounts={eventDetails[0]?.entryCountsByPlayerId}
                  />
                ) : (
                  <>
                    {currentCompetition?.drawModel === "groups" ? (
                      ""
                    ) : (
                      <Eliminatory
                        readOnly
                        currentCompetition={currentCompetition}
                        operation={operation}
                  socketClientId={socketClientId}
                        eventId={eventId}
                        competitionId={competitionId}
                        gameType={phase.gameType}
                        phaseId={phase._id}
                        luckyDraw={phase.luckyDraw}
                        eventContext={eventDetails[0]}
                        allCompetitions={eventDetails[0]?.competitions}
                        eventEntryCounts={eventDetails[0]?.entryCountsByPlayerId}
                      />
                    )}
                  </>
                )}
                {currentCompetition?.drawModel === "groups" &&
                currentCompetition?.phases[0]?.drawModel === "eliminatory" ? (
                  ""
                ) : (
                  <DrawActionGroup operation={operation} phaseId={phase._id}>
                    {/* No phase Redraw: the gateway routes no phase redraw and Events' draw takes no phase; Phases generates phase draws. */}
                    <Button
                      onClick={() => openMainDrawConfirmation(phase?._id)}
                      className="pl-2 pr-2 mb-4 mt-3"
                      color="success"
                      disabled={mainDrawActionDisabled}
                    >
                      {mainDrawActionLabel}
                    </Button>
                  </DrawActionGroup>
                )}
              </div>
            ) : (
              ""
            )}
          </>
        ))}
        <DrawActionLogs key={competitionId} competitionId={competitionId} timezone={eventDetails[0]?.timezone} refresh={operation.status} />
        <Modal isOpen={modal === "redraw"} toggle={() => setModal(null)}>
          <ModalHeader>Re-draw positions</ModalHeader>
          <ModalBody>
            <p>Are you sure you want to redraw entries positions?</p><p>This changes Lucky Draw positions. Existing Main Draw matches remain as they are.</p>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={async () => {
                setModal(null)
              }}
              color="secondary"
            >
              No
            </Button>
            <Button
              onClick={async () => {
                operation.run("redraw")
                setModal(null)
              }}
              color="primary"
            >
              Yes
            </Button>
          </ModalFooter>
        </Modal>
        <MainDrawConfirmationModal
          open={!!mainDrawConfirmation}
          confirmation={mainDrawConfirmation}
          onCancel={closeMainDrawConfirmation}
          onConfirm={confirmMainDraw}
        />
      </div>
      </DrawPlayerDetails>
    </div>
  )
}

const DrawActionGroup = ({ operation, phaseId = "primary", children }) => {
  const reason = drawLockReason(operation)
  const descriptionId = `draw-actions-${phaseId}-reason`
  return <div className="Luckydraw__actions" role="group" aria-label="Draw actions"
    aria-disabled={Boolean(reason)} aria-describedby={reason ? descriptionId : undefined}
    tabIndex={reason ? 0 : undefined} title={reason}>
    {children}
    {reason && <p className="text-muted" id={descriptionId}>{reason}</p>}
  </div>
}

const MainDrawConfirmationModal = ({
  open,
  confirmation,
  onCancel,
  onConfirm,
}) => {
  const confirmationCopy = getMainDrawConfirmationCopy(confirmation)

  return (
    <Modal isOpen={open} toggle={onCancel}>
      <ModalHeader toggle={onCancel}>{confirmationCopy.title}</ModalHeader>
      <ModalBody>
        {confirmationCopy.body.map(message => (
          <p className="mb-2" key={message}>
            {message}
          </p>
        ))}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancel}>
          {confirmationCopy.cancelLabel}
        </Button>{" "}
        <Button color="primary" onClick={onConfirm}>
          {confirmationCopy.confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

const NotGeneratedDraw = ({ eventId, competitionId }) => {
  return (
    <Card className="w-100">
      <CardBody>
        <p>No Lucky Draw yet.</p>
        <p className="mb-0">Generate the initial Lucky Draw from Entries. <Link to={`/events/${eventId}/competitions/${competitionId}/entries`}>Open Entries</Link></p>
      </CardBody>
    </Card>
  )
}

const mapStateToProps = ({ events: { eventDetails = [], loading = false, error = null } = {} }) => ({
  eventDetails, loading, error,
})

export default connect(mapStateToProps, {
  getEventDetails: getEventDetailsAction,
})(Draw)
